import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../api";
import { ErrorBanner } from "../components/ui";
import { BrandLockup } from "../components/BrandLockup";

// ログイン中の本人によるパスワード変更。
export function PasswordChangePage() {
  const nav = useNavigate();
  const [currentPassword, setCurrent] = useState("");
  const [newPassword, setNew] = useState("");
  const [newPassword2, setNew2] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-tora-paper">
      <header className="bg-white border-b-2 border-tora-accent">
        <div className="mx-auto max-w-7xl px-4 py-3 flex items-center justify-between">
          <BrandLockup compact />
          <Link to="/mypage" className="tap-target text-sm text-tora hover:underline">
            マイページへ戻る
          </Link>
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 py-10">
        {done ? (
          <div className="card w-full max-w-md p-6 md:p-8 shadow-md text-center">
            <h1 className="text-2xl font-bold text-tora-ink">
              パスワードを変更しました
            </h1>
            <p className="text-sm text-tora-ink/70 mt-3">
              他の端末のセッションはログアウトされました。
            </p>
            <button
              className="btn-primary btn-lg w-full mt-6"
              onClick={() => nav("/mypage", { replace: true })}
            >
              マイページへ
            </button>
          </div>
        ) : (
          <form
            className="card w-full max-w-md p-6 md:p-8 shadow-md"
            onSubmit={async (e) => {
              e.preventDefault();
              setErr(null);
              if (newPassword !== newPassword2) {
                setErr("新しいパスワードが一致しません");
                return;
              }
              setBusy(true);
              try {
                await api.post("/auth/password-change", {
                  currentPassword,
                  newPassword,
                });
                setDone(true);
              } catch (e) {
                setErr((e as Error).message ?? "変更に失敗しました");
              } finally {
                setBusy(false);
              }
            }}
          >
            <h1 className="text-2xl font-bold text-tora-ink">パスワード変更</h1>
            <p className="text-sm text-tora-ink/70 mt-1 mb-6">
              現在のパスワードと新しいパスワードを入力してください。
            </p>

            <div className="mb-4">
              <label className="label" htmlFor="cur">
                現在のパスワード
              </label>
              <input
                id="cur"
                type="password"
                className="input"
                value={currentPassword}
                onChange={(e) => setCurrent(e.target.value)}
                required
                autoComplete="current-password"
                autoFocus
              />
            </div>
            <div className="mb-4">
              <label className="label" htmlFor="np">
                新しいパスワード（8文字以上）
              </label>
              <input
                id="np"
                type="password"
                className="input"
                value={newPassword}
                onChange={(e) => setNew(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>
            <div className="mb-4">
              <label className="label" htmlFor="np2">
                新しいパスワード（確認）
              </label>
              <input
                id="np2"
                type="password"
                className="input"
                value={newPassword2}
                onChange={(e) => setNew2(e.target.value)}
                required
                minLength={8}
                autoComplete="new-password"
              />
            </div>
            {err && <ErrorBanner className="mb-3">{err}</ErrorBanner>}
            <button className="btn-primary btn-lg w-full" disabled={busy}>
              {busy ? "変更中…" : "パスワードを変更"}
            </button>
          </form>
        )}
      </main>
    </div>
  );
}
